import PropTypes from 'prop-types'
import React from 'react'
import { MdDescription, MdHome, MdShowChart } from 'react-icons/md'

import './chip.scss'

import CMIcon from '../../../../assets/svgs/cm.svg?component'
import GrandRoundsIcon from '../../../../assets/svgs/gr.svg?component'
import PatientIcon from '../../../../assets/svgs/patient.svg?component'
import PhoneIcon from '../../../../assets/svgs/phone.svg?component'
import VirtualIcon from '../../../../assets/svgs/virtual.svg?component'
import { FriendlyDateTime } from '../../Date/friendly-date-time'

const encounterTypeToIconMapper = {
  patient: <PatientIcon />,
  grandRounds: <GrandRoundsIcon />,
  cms: <MdShowChart />,
  cm: <CMIcon />,
  administrative: <MdDescription />,
  virtual: <VirtualIcon />,
  phone: <PhoneIcon />,
  home: <MdHome />
}

export class NarusChip extends React.Component {
  renderTime () {
    /**
     * @type {string | undefined}
     */
    let time = this.props.time
    time = time.replace('Z', '+00:00')
    if (time) {
      let hasTimeZone = (
        /Z^/i.test(time) ||
        /[-+]\d{1,2}:\d{1,2}$/.test(time)
      )

      if (!hasTimeZone) {
        time += 'Z'
      }

      return (
        <div className='chip-time'>
          <FriendlyDateTime
            short
            datetime={time}
          />
        </div>
      )
    }
    return null
  }

  render () {
    const { text, icon, disableHover } = this.props
    if (icon && disableHover) {
      return (
        <div className='row middle-xs center-xs disable-hover nh-chip no-margin'>
          <div className='icon-wrapper'>
            {encounterTypeToIconMapper?.[icon]}
          </div>
          <div className='chip-info-wrapper'>
            <div className='text'>{text}</div>
            {this.renderTime()}
          </div>
        </div>
      )
    }

    if (icon) {
      return (
        <div className='row middle-xs nh-chip no-margin'>
          <div className='icon-wrapper'>
            {encounterTypeToIconMapper?.[icon]}
          </div>
          <div className='chip-info-wrapper'>
            <div className='text'>{text}</div>
            {this.renderTime()}
          </div>
        </div>
      )
    }

    if (disableHover) {
      return (
        <div className='nh-chip disable-hover'>
          <div className='chip-info-wrapper'>
            <div className='text'>{text}</div>
            {this.renderTime()}
          </div>
        </div>
      )
    }

    return (
      <div className='nh-chip z-depth-1' >
        <div className='chip-info-wrapper'>
          <div className='text'>{text}</div>
          {this.renderTime()}
        </div>
      </div>
    )
  }
}

NarusChip.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,
  disableHover: PropTypes.bool
}

export default NarusChip
